import { ComponentProps } from 'react';

import { FormSelectField } from '@sbv-clients/ui-forms';

type FormatFieldProps = ComponentProps<typeof FormSelectField>;
const options = [
  { id: '1', label: 'Excel', value: 1 },
  { id: '2', label: 'PDF', value: 2 },
];

export const FileFormatFormField = (props: FormatFieldProps) => {
  return <FormSelectField {...props} options={options} size="small" />;
};
